import { render, staticRenderFns } from "./CreditLimit.vue?vue&type=template&id=903331c4&scoped=true"
import script from "./CreditLimit.vue?vue&type=script&lang=js"
export * from "./CreditLimit.vue?vue&type=script&lang=js"
import style0 from "./CreditLimit.vue?vue&type=style&index=0&id=903331c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903331c4",
  null
  
)

export default component.exports